import './LoadingButton.css';
import { Button, Spinner } from 'react-bootstrap';

const LoadingButton = ({
    children,
    isLoading,
    onClick,
    variant = 'primary',
    isDisabled = false,
    type = 'button',
    className = '',
    maxWidth = '200px',
}) => {
    return (
        <Button
            onClick={onClick ? () => onClick() : undefined}
            variant={variant}
            className={`loadingBtn ${className}`}
            disabled={isLoading || isDisabled}
            type={type}
            style={{ maxWidth }}
        >
            {isLoading && <Spinner className="loader"></Spinner>}
            <span style={{ visibility: isLoading ? 'hidden' : 'visible' }}>{children}</span>
        </Button>
    );
};

export default LoadingButton;
